import { Component, OnInit, Input, ViewChild, ElementRef, AfterViewInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import {FormControl,FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ProgramService, OauthService, UserService, TDSDateAdapter, AccountSettingService, SessionService } from '@terradotta/commons';
import { DateAdapter } from '@angular/material/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import {debounceTime, finalize, tap, filter, map, takeUntil } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie';
import { ReplaySubject, Subject } from 'rxjs';

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.scss'],
  providers: [{
    provide: DateAdapter,
    useClass: TDSDateAdapter,
    deps: [AccountSettingService]
  }]
})
export class RegistrationComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() primaryColor: string;
  @Input() loginRegistrationOptions: any;
  @Input() rcValue: number;
  @Input() programId: number;
  @Input() i18nFields: any;
  @Input() institutionName: string;

  tdRegistrationForm: FormGroup;
  hidePassWord = true;
  hidePassWordConfirm = true;
  registrationDoB: boolean = false;
  registrationGender: boolean = false;
  registrationHomeInstitution: boolean = false;
  pwMin:number;
  requiredPasswordLength: number;
  registrationGDPR: boolean = false;
  pwMixed: string = '';
  pwNum: string = '';
  pwSpecChar: string = '';
  pwReqs: string = ''
  hInst:any;
  pwHasNumber: boolean = false;
  pwHasMixed: boolean = false;
  pwHasSpChar: boolean = false;
  homeInstitutionListLoading: boolean = false;  
  loadingSpinner: boolean = false;
  homeInstitutionList: any[]=[];
  requirePartnerInstitution: boolean = false;
  requireHomeInstitution: boolean = false;
  partnerInstitutionList: any;
  loginResponse: any;
  searching: boolean = false;
  integratedUser: boolean;
  institutionDeterminer: string = '';
  filteredServerSideHomeInstitutions: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  @Output() activeAppCycleResults: EventEmitter<any> = new EventEmitter<any>();
  @Output() formMode: EventEmitter<any> = new EventEmitter<any>();
  @Output() redirectURL: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('homeInstitution') homeInstitution: ElementRef
  userTypeOptions: any[]=[];
  homeInstHint: boolean = false;
  showUserType: boolean = false;
  // @ViewChild('homeSearch') homeSearch: ElementRef;
  protected _onDestroy = new Subject<void>();

  constructor(
    private fb: FormBuilder,    
    private _programService: ProgramService,
    private _oauthService: OauthService,
    private _sessionService: SessionService,
    private snackbar: MatSnackBar,
    private _userService: UserService,
    private _cookieService: CookieService,
    private _accountSettingService: AccountSettingService

    ) {
   
   }

  ngOnInit() {
    var that = this;

    this.pwMin = this.loginRegistrationOptions.passwordMinCharLength
    if(this.loginRegistrationOptions.requirePasswordMixedCase){
      this.pwMixed = '(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z])';
    }
    if(this.loginRegistrationOptions.requirePasswordNumber){
      this.pwNum = '(?=.*[0-9])';
    }
    if(this.loginRegistrationOptions.requirePasswordCharacter){
      this.pwSpecChar = '(?=.*[~`!@#$%^&*+=-[];,/{}|":<>?()._])';
    }
    if(this.loginRegistrationOptions.enableManualEntryOfHomeInst || this.loginRegistrationOptions.homeInstitution){
      this.requireHomeInstitution = true
    }
    if(!this.loginRegistrationOptions.externalStudentsEnabled && this.loginRegistrationOptions.internalStudentsEnabled && !this.loginRegistrationOptions.SCLEnabled){
      this.requireHomeInstitution = false;
    }
    if(this.loginRegistrationOptions.partnerInstitutions && this.loginRegistrationOptions.partnerInstitutions.length > 0){
      this.requirePartnerInstitution = true;
      this.partnerInstitutionList = this.loginRegistrationOptions.partnerInstitutions;
      this.requireHomeInstitution = false;
    }
    // (?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z])(?=.*[\s~`!@#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?()\._]){0,}$
    this.pwReqs = this.pwMixed+this.pwNum+this.pwSpecChar+'.{'+this.pwMin+',}';
    this.tdRegistrationForm = this.createRegistrationForm();
    let passwordValidators: any[] = [Validators.required];
    if(this.pwMin > 0){
      passwordValidators.push(Validators.minLength(this.pwMin))
    }
    if(this.loginRegistrationOptions.requirePasswordNumber){
      passwordValidators.push(this.authNumPassword)
    }
    if(this.loginRegistrationOptions.requirePasswordMixedCase){
      passwordValidators.push(this.authMixedPassword)
    }
    if(this.loginRegistrationOptions.requirePasswordCharacter){
      passwordValidators.push(this.authSCPassword)
    }
    // if(this.loginRegistrationOptions.enableManualEntryOfHomeInst && this.loginRegistrationOptions.externalStudentsEnabled){      
    //   this.tdRegistrationForm.get('tdHomeInstitution').setValidators([Validators.required]);
    // }
    if(this.loginRegistrationOptions.homeInstitution && this.requireHomeInstitution){
      this.homeInstHint = true
      this.tdRegistrationForm.get('tdHomeInstitution').setValidators([Validators.required]);
    }
    if(this.loginRegistrationOptions.externalStudentsEnabled && this.loginRegistrationOptions.internalStudentsEnabled &&  !this.loginRegistrationOptions.SCLEnabled){
      this.tdRegistrationForm.get('tdUserType').setValidators([Validators.required])
      this.showUserType = true;
    }
    if(this.loginRegistrationOptions.partnerInstitutions && this.loginRegistrationOptions.partnerInstitutions.length > 0){      
      this.tdRegistrationForm.get('tdPartnerInstitution').setValidators([Validators.required]);
      this.tdRegistrationForm.get('tdHomeInstitution').setValidators([]);
    }
    this.tdRegistrationForm.get('tdPassword').setValidators(passwordValidators);
    this.tdRegistrationForm.setValidators(this.checkPasswords);
  
    if(this.requireHomeInstitution){
      // listen for search field value changes
      this.tdRegistrationForm.get('homeSearch').valueChanges
      .pipe(
        filter(search => !!search),
        tap(() => this.searching = true),
        takeUntil(this._onDestroy),
        debounceTime(200),
        map(search => {          
          if (!this.homeInstitutionList) {
            return [];
          }
          let keywords = {
            keyword: [search]
          }
          return keywords
        }),
      )
      .subscribe(keywords => {
        this._userService.findHomeInstitution(keywords).pipe(
          finalize(() => this.homeInstitutionListLoading = false)).subscribe(resp => {
              this.homeInstitutionList = resp;
              this.searching = false;
              this.filteredServerSideHomeInstitutions.next(this.homeInstitutionList);
            });        
      },
        error => {
          // no errors in our simulated example
          this.searching = false;
          // handle error...
        });
      }
      var vowelRegex = '^[aieouAIEOU].*'
      var u = this.institutionName.startsWith('University');
      var matched = this.institutionName.match(vowelRegex)
      if(matched && !u)
      {
        this.institutionDeterminer = 'an'
      }
      else
      {
        this.institutionDeterminer = 'a'
      }

      this.userTypeOptions = [
        {displayText:'I am ' + this.institutionDeterminer + ' ' + this.institutionName + ' user', value:false},
        {displayText:'I am not a user at ' + this.institutionName, value:true},
      ]
      
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  ngAfterViewInit(){    
  }
  createRegistrationForm(){
    return this.fb.group({
      tdEmail: ['', [Validators.required, Validators.email]],
      tdFirstName:['', Validators.required],      
      tdLastName:['', Validators.required],      
      tdMiddleName:[''],      
      tdPassword:[''],      
      tdPasswordConfirm:[''], 
      tdHomeInstitution:[''],  
      homeSearch:[''],
      tdPartnerInstitution:[''],
      partnerSearch:[''],
      tdUserPhone:[''],
      tdUserType:[null]
    });
  }


  checkPasswords(tdRegistrationForm: FormGroup) { // here we have the 'passwords' group
    let pass = tdRegistrationForm.get('tdPassword').value;
    let confirmPass = tdRegistrationForm.get('tdPasswordConfirm').value;
    if(pass !== confirmPass){
      tdRegistrationForm.get('tdPasswordConfirm').setErrors({notMatch:true});
    } else {
      tdRegistrationForm.get('tdPasswordConfirm').setErrors(null);
    }
    return pass === confirmPass ? null : { notMatch:true }
  }

  authNumPassword(control: FormControl){
    if(!control.pristine){
      let pass = control.value;
      const pwNoNumber = !/\d/.test(pass);
      
      if(pwNoNumber){
        return {pwNoNumber:true};
      } else {
        return null;
      } 
    } else {
      return null;
    }
  }
  authMixedPassword(control: FormControl){
    if(!control.pristine){
      let pass = control.value;
      const pwNoMixed = !/(?=.*[a-z])(?=.*[A-Z])/.test(pass);
      // console.log('pwNoMixed = ' + pwNoMixed);
      if(pwNoMixed){
        return {pwNoMixed:true};
      } else {
        return null;
      }     
    } else {
      return null;
    }
  }
  authSCPassword(control:FormControl){
    if(!control.pristine){
      let pass = control.value;
      const pwNoSC = !/[\s~`!@#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?()\._]/.test(pass);
      // console.log('pwNoSC = ' + pwNoSC);
      if(pwNoSC){
        return {pwNoSC:true};
      } else {
        return null;
      }     
    } else {
      return null;
    }
  }
  // loadHomeInstitutionList(keyword){
  //   debugger
  //   this.homeInstitutionListLoading = true;
  //   this._userService.findHomeInstitution(keyword).pipe(
  //     finalize(() => this.homeInstitutionListLoading = false)
  //   ).subscribe(resp => {
  //     this.homeInstitutionList = resp.sort((a,b) => {
  //        a.homeInstitutionName.toLocaleLowerCase().localeCompare(b.homeInstitutionName.toLocaleLowerCase());
  //     });
  //   });
  // }
  homeInstitutionValidator(){
    if(this.requireHomeInstitution && !this.tdRegistrationForm.value.tdUserType){      
      this.tdRegistrationForm.get('tdHomeInstitution').clearValidators();
      this.tdRegistrationForm.get('tdHomeInstitution').updateValueAndValidity();
    } else if(this.requireHomeInstitution && (!this.tdRegistrationForm.value.tdUserType || this.tdRegistrationForm.value.tdUserType === null)) {
      this.tdRegistrationForm.get('tdHomeInstitution').setValidators([Validators.required]);
      this.tdRegistrationForm.get('tdHomeInstitution').updateValueAndValidity();
     
    } else if(this.loginRegistrationOptions.homeInstitution){
      this.homeInstHint = true
      this.tdRegistrationForm.get('tdHomeInstitution').setValidators([Validators.required]);
      this.tdRegistrationForm.get('tdHomeInstitution').updateValueAndValidity();
    }
  }

  siteRegistrationSubmit(){
    this.loadingSpinner = true;
    if(this.tdRegistrationForm.get('tdUserType').value === null && this.loginRegistrationOptions.externalStudentsEnabled){
      this.tdRegistrationForm.get('tdUserType').setValue(true)
    } else if(this.tdRegistrationForm.get('tdUserType').value === null && !this.loginRegistrationOptions.externalStudentsEnabled && this.loginRegistrationOptions.internalStudentsEnabled){
      this.tdRegistrationForm.get('tdUserType').setValue(false)
    } else {
      this.tdRegistrationForm.get('tdUserType').value;
    }
    let userRegistration = {
      username: this.tdRegistrationForm.get('tdEmail').value,
      firstName: this.tdRegistrationForm.get('tdFirstName').value,
      middleName: this.tdRegistrationForm.get('tdMiddleName').value,
      lastName: this.tdRegistrationForm.get('tdLastName').value,
      password: this.tdRegistrationForm.get('tdPassword').value,
      userPhone: this.tdRegistrationForm.get('tdUserPhone').value,
      homeInstitution: this.tdRegistrationForm.get('tdHomeInstitution').value,
      partnerInstitution: this.tdRegistrationForm.get('tdPartnerInstitution').value,
      userType: this.tdRegistrationForm.get('tdUserType').value
    }    
    this._userService.createUser(userRegistration).subscribe(resp => {
      if(this.rcValue > 0){
        var RC = this.rcValue
      }
      let tdUserInfo = {
        userName: this.tdRegistrationForm.get('tdEmail').value,
        userPassword: this.tdRegistrationForm.get('tdPassword').value,
        RC
      } 
      this._oauthService.userLogin(tdUserInfo).subscribe(async res => {
        try {
          const session: any = await this._sessionService.create();
          if(session && session.session_id) {
            localStorage.setItem('tds-session', session.session_id);
            await this._sessionService.update(session.session_id, { user_name: tdUserInfo.userName }).toPromise();
            const sessionData = await this._sessionService.get(session.session_id);
            if(sessionData && sessionData.session_data) {
              this._sessionService.updateCache(sessionData);
              if(localStorage.getItem('tds-session-renewing') == 'true') {
                localStorage.setItem('tds-session-renewed', 'true');
                localStorage.removeItem('tds-session-renewing');
              }
            }
          }
        } catch(e) {
          this.snackbar.open('There was an error while trying to register the user.', 'Dismiss', { duration: 5000 });
        }
        this.loginResponse = res;
        this._oauthService.getToken(true).then((token) => {
          if(token){
            this.loginRedirect(); 
          }
        }).catch(() => {
          this.snackbar.open('There was an error while trying to register the user.', 'Dismiss', { duration: 5000 });
        })
      })
    },err => {
      if(err.status === 409){
        let msg: string = 'There is a user that already exists with this email. Please return to the login page to login.';      
      this.snackbar.open(msg,'Dismiss',{
        duration: 6000
      });
      this.loadingSpinner = false;
      } else {
        let msg: string = 'There was an error while trying to register this user. Please try again. ';      
        this.snackbar.open(msg,'Dismiss',{
          duration: 6000
        });
        this.loadingSpinner = false;
      }
      
    })
  }
  loginRedirect(){
    if(this.loginResponse.returnURL !== ''){
      window.location.href = window.location.origin + '/' + this.loginResponse.returnURL        
    } else {      
      window.location.href = window.location.origin + '/index.cfm?FuseAction=Portal.Home';
    }
  }

}
